import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@app-i18n/i18n.module';
import { ErrorComponent } from '@app-shared/components/error/error.component';
import { InputErrorComponent } from '@app-shared/components/input-error/input-error.component';
import { ToolTipComponent } from '@app-shared/components/tool-tip/tool-tip.component';
import { Relay42Directive } from '@app-shared/directives/relay42.directive';
import { CardValidatorDirective } from '@app/shared/directives/card-validator.directive';

const components = [ToolTipComponent, ErrorComponent, InputErrorComponent];
const directives = [Relay42Directive, CardValidatorDirective];
const declarations = [...components, ...directives];

@NgModule({
  declarations,
  imports: [CommonModule, I18nModule],
  exports: [...declarations]
})
export class SharedModule {}
